/** True for the statuses in which a job is still being generated. */
export var isReportJobActive = function (status) {
    return status === "PENDING" || status === "RUNNING";
};
